jQuery(document).ready(function ($) {
  $(document).on('keydown', function (e) {
    var keyCode = e.keyCode || e.which;
    var target = e.target;
    if (keyCode == 9 && $(target).closest('li').hasClass('top-level')) {
      $(target).next('.sub-menu').slideDown();
    }
  });
});
jQuery(document).ready(function ($) {
  // Simple accordion functionality
  $('.accordion__group button').on('click', function (e) {
    e.preventDefault();

    // If item clicked on is open, close it
    if ($(this).closest('.accordion__group').hasClass('active')) {
      $(this).closest('.accordion__group').removeClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideUp();
    } else {
      // Otherwise, close all others and open the one clicked on
      $(this).closest('.accordion__group').siblings().removeClass('active');
      $(this).closest('.accordion__group').siblings().find('.accordion__copy').slideUp();
      $(this).closest('.accordion__group').addClass('active');
      $(this).closest('.accordion__group').find('> .accordion__copy').slideToggle();
    }
  });
});
jQuery(document).ready(function ($) {
  // Show / hide address add form
  $('.customer--addresses .add-address').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  });

  // Show / hide address add form
  $('.customer--addresses .add-address-cancel').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  });
});
jQuery(document).ready(function ($) {
  /******************************************
     QTY Selector ( Simple quantity box increase / decrease )
    ******************************************/

  // PDP / PLP
  $('body').on('click', '.js-qty:not(.js-qty--cart)', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    // *** CODE CHANGE *** Updated line below
    var maxVal = parseInt($(this).closest('.qty').find('input').attr('bulkOrderMax'));
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;
    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    }
    qtyInput.val(qtyInputVal);
    // *** CODE CHANGE *** Updated line below
    if (qtyInputVal > maxVal && maxVal > 0) {
      alert('Quantity entered exceeds available inventory.');
      $(this).closest('.qty').find('input').val(maxVal);
    }
  });
  $('body').on('input', '[sm-rc-quantity-selector]', function () {
    var qty = parseInt($(this).val());
    // *** CODE CHANGE *** Updated line below
    var maxVal = parseInt($(this).attr('bulkOrderMax'));
    // *** CODE CHANGE *** Updated line below
    if (qty > maxVal && maxVal > 0) {
      alert('Quantity entered exceeds available inventory.');
      $(this).val(maxVal);
    }
  });
  $('body').on('click', '.card--product  .btn--atc', function () {
    var id = $(this).attr('data-id');
    CartJS.addItem(parseInt(id), 1, {}, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          window.Rebuy?.SmartCart?.show?.();
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        //error state
        console.log('Error: ' + errorThrown + '!');
      }
    });
  });

  // MAIN CART

  // Allow typing of input qty for update
  var timer;
  $('.col__qty, .mobile-stuff').on('keyup', '.qty input', function () {
    var $this = $(this);
    var newVal = $this.val();
    var lineNum = $this.closest('.cart-row').attr('data-linenum');

    // clear the previous timer
    clearTimeout(timer);

    // create a new timer with a delay of 300ms seconds,
    // if the keyup is fired before the 300ms secs then the timer will be cleared
    timer = setTimeout(function () {
      // this will be executed if there is a gap of 300ms seconds between 2 keyup events
      CartJS.updateItem(lineNum, newVal, {}, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
      });
    }, 300);
  });
  $('.col__qty, .mobile-stuff').on('click', '.js-qty--cart', function (e) {
    e.preventDefault();
    var $this = $(this);
    var qtyInput = $this.closest('.qty').find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;
    var lineNum = $this.closest('.cart-row').attr('data-linenum');
    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    }
    if (qtyInputVal >= 1) {
      // console.log('got here');
      CartJS.updateItem(lineNum, qtyInputVal, {}, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
      });
    } else {
      CartJS.removeItem(lineNum, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
      });
    }
  });

  // MAIN CART REMOVE
  $('.actions .remove-product').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var lineID = $this.closest('.cart-row').attr('data-lineid');
    CartJS.removeItemById(lineID, {
      success: function success(data, textStatus, jqXHR) {
        location.reload();
      },
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  });

  /******************************************
     Options to change SM-RC Widget dropdowns
    ******************************************/

  // SELECT TYPE
  $('body').on('change', '.option__wrap select', function () {
    var optionVal = $(this).val();
    var optionNum = $(this).closest('.option__wrap').attr('data-option');
    $('select[' + optionNum + ']').val(optionVal).change();
  });

  // BUTTON TYPE
  $('body').on('click', '.option__wrap button', function (e) {
    var optionVal = $(this).attr('data-val');
    var optionNum = $(this).closest('.option__wrap').attr('data-option');
    if ($(this).hasClass('btn--swatch')) {
      $(this).closest('.option__wrap').find('.color-val').text(optionVal);
    }

    // Set visual display of active
    $(this).closest('.option__wrap').find('button').removeClass('active');
    $(this).addClass('active');
    $('select[' + optionNum + ']').val(optionVal).change();
  });

  // RECHARE WIDGET VARIANTS
  $('.pdp__recharge input').on('click', function () {
    if ($(this).val() == 'rc-yes') {
      $('.form__group--rc').show();
      var planId = $(this).closest('.pdp__recharge').find('.frequency-select').val();
      $('[sm-rc-plan-selector]').val(planId).change();
    } else {
      $('.form__group--rc').hide();
      $('[sm-rc-plan-selector]').val('false').change();
    }
  });

  // RECHARE WIDGET SUBSCRIPTION PLAN
  $('.template__product .frequency-select').on('change', function () {
    var planId = $(this).val();
    $('[sm-rc-plan-selector]').val(planId).change();
  });
});
jQuery(document).ready(function ($) {
  // Make mobile category selector go to tag page
  $('.blog__tags select').on('change', function () {
    var tagUrl = $(this).val();
    window.location = tagUrl;
  });
});
jQuery(document).ready(function ($) {
  /******************************************
    Bulk Order Form
   ******************************************/
  // Show price increase per lineitem
  $('.bulk-order-form .variant__qty input').on('input', function () {
    var price = $(this).closest('.variant__row').attr('data-price');
    var qty = parseInt($(this).val());
    var lineTotal = qty * price;
    var lineTotalMoney = formatter.format(lineTotal / 100);
    // *** CODE CHANGE *** Updated line below
    var maxVal = parseInt($(this).attr('bulkOrderMax'));
    console.log('maxVal:' + maxVal + ' qty: ' + qty);
    var doTotal = true;
    // *** CODE CHANGE *** Updated line below
    if (qty > maxVal && maxVal > 0) {
      alert('Quantity entered exceeds available inventory.');
      $(this).val('');
      $(this).closest('.variant__row').find('.variant__total span').text('$0.00');
      doTotal = false;
    } else {
      // Change the line-item subtotal
      $(this).closest('.variant__row').find('.variant__total span').text(lineTotalMoney);
      doTotal = true;
    }
  });
  if (doTotal = true) {
    // Change the order total in sticky footer
    $('.bulk-order-form .variant__qty input').on('input', function () {
      var sum = 0;
      var totalQty = 0;
      $('.variant__row:not(.variant--sold-out)').each(function (index, value) {
        var price = $(this).attr('data-price');
        var qty = $(this).find('.variant__qty input').val();
        var lineTotal = qty * price;

        // console.log('price: ' + price);
        // console.log('qty :' + qty);
        // console.log('lineTotal: ' + lineTotal);

        sum += lineTotal;
        totalQty += parseInt(qty);
      });
      var sumTotal = formatter.format(sum / 100);
      $('.sticky-footer .total .amount').text(sumTotal);
      $('.sticky-footer .total .amount').attr('data-total', sum);
      $('.sticky-footer .total .amount').attr('data-qty', totalQty);
    });
  }

  // Add all to cart
  $('.bulk-order-form .sticky-footer .btn--bulk-add').on('click', function () {
    var varIdList = [];
    var totalNum = parseInt($('.total .amount').attr('data-total'));
    var totalQty = parseInt($('.total .amount').attr('data-qty'));
    console.log('totalNum: ' + totalNum);
    console.log('totalQty: ' + totalQty);
    if (totalNum > 0 || totalQty > 0) {
      $('.bulk-order-form .loader').show();
      $('.bulk-order-form .variant__row').each(function (index, value) {
        var variantID = $(this).attr('data-id');
        var variantQty = $(this).find('.variant__qty input').val();
        if (variantQty > 0) {
          varIdList.push({
            id: variantID,
            quantity: variantQty
          });
        }
      });
      CartJS.addItems(varIdList.reverse(), {
        success: function success(data, textStatus, jqXHR) {
          jQuery.getJSON('/cart.js', function (cart) {
            refreshMiniCart(cart);
          });
          $('.bulk-order-form .variant__qty input').val(0);
          $('.sticky-footer .total .amount').text('$0.00');
          $('.sticky-footer .total .amount').attr('data-total', 0);
          $('.bulk-order-form .loader').hide();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log('Error: ' + errorThrown + '!');
        }
      });
    } else {
      alert('Please add inventory to add to cart.');
    }
    console.log(varIdList);
  });
});
jQuery(document).ready(function ($) {
  var windowWidth = $(window).width();
  var links = document.links;
  for (var i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname && !links[i].classList.contains('icon--account')) {
      links[i].target = '_blank';
    }
  }

  /******************************************
     Header Search
   ******************************************/

  // Show desktop search on click and focus on input
  $('.icon--search').on('click', function (e) {
    e.preventDefault();
    $('.desktop-search').fadeIn('fast', '', function () {
      $('body').addClass('search-open');
      $('.desktop-search input').focus();
    });
  });

  // Close desktop search if click outside
  $('body').on('click', function (e) {
    var desktopSearch = $('.desktop-search');
    if (!desktopSearch.is(e.target) && desktopSearch.has(e.target).length === 0 && $('body').hasClass('search-open')) {
      desktopSearch.fadeOut('fast', '', function () {
        $('body').removeClass('search-open');
        $('.icon--search').focus();
        $('#boost-sd__search-widget-init-wrapper').addClass('boost-sd__g-hide');
      });
    }
  });
  $('.modal--chart .table td').on('mouseenter', function (e) {
    var index = $(this).index() + 1;
    $(this).closest('table').find('th:nth-child(' + index + ')').addClass('active');
    // console.log();
  });
  $('.modal--chart .table td').on('mouseleave', function (e) {
    var index = $(this).index() + 1;
    $(this).closest('table').find('th:nth-child(' + index + ')').removeClass('active');
    // console.log();
  });

  /******************************************
     Mobile Menu
   ******************************************/

  // Trigger mobile menu display
  $('.icon--mobile button').on('click', function () {
    $(this).toggleClass('is-active');
    $('html').toggleClass('mobile-menu-open');
    $('.mobile-menu').fadeToggle(230, '', function () {});
  });

  // Hide / Show panels on mobile menu
  $('.mobile-menu .top-level.has-children a').on('click', function (e) {
    e.preventDefault();
    var dataTitle = $(this).attr('data-title');
    $('.mobile-menu__front').fadeOut(170, function () {
      $('.mobile-menu__back[data-title="' + dataTitle + '"]').fadeIn(170);
    });
  });
  $('.mobile-menu .sub__heading .back').on('click', function () {
    $('.mobile-menu__back').fadeOut(170, function () {
      setTimeout(function () {
        $('.mobile-menu__front').fadeIn(220);
      }, 150);
    });
  });
  $('.icon--cart').on('click', function () {
    window.Rebuy.SmartCart.show();
  });

  /******************************************
    Quick Buy Modal
   ******************************************/
  // Cache of in-flight / resolved product fetches, keyed by handle, so a hover
  // or touchstart can warm the request before the shopper clicks. On a cold
  // load the /products/{handle}.js fetch competes with a flood of same-host
  // requests for the browser's ~6-connections-per-host limit, so starting it a
  // few hundred ms early (on hover) meaningfully shortens the perceived wait.
  window.qvProductCache = window.qvProductCache || {};
  function qvFetchProduct(handle) {
    if (!handle) return Promise.reject(new Error('no handle'));
    if (window.qvProductCache[handle]) return window.qvProductCache[handle];
    var req = fetch(window.Shopify.routes.root + 'products/' + handle + '.js').then(function (response) {
      if (!response.ok) throw new Error('Product fetch failed: ' + response.status);
      return response.json();
    });
    // Don't cache a rejected fetch — let a later click retry from scratch.
    req.catch(function () {
      delete window.qvProductCache[handle];
    });
    window.qvProductCache[handle] = req;
    return req;
  }

  // Read product data rendered inline in the card (see card-product.liquid).
  // Returns the parsed product object, or null if no inline data is present
  // (e.g. Boost collection cards, which still use the fetch path).
  function qvInlineProduct($btn) {
    var el = $btn.closest('.card--product').find('script.qv-inline-data')[0];
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Warm the cache on hover (desktop) and touchstart (mobile fires before the
  // click), so the product JSON is usually already in flight by click time.
  // Skipped entirely for cards that carry inline data — those never fetch.
  $('body').on('mouseenter touchstart', '.card--product .btn--quick-buy', function () {
    var $btn = $(this);
    // If the card carries inline product data, no fetch is ever needed.
    if ($btn.closest('.card--product').find('script.qv-inline-data').length) return;
    qvFetchProduct($btn.attr('data-handle'));
  });

  $('body').on('click', '.card--product .btn--quick-buy', function () {
    var $btn = $(this);
    if ($btn.hasClass('is-loading')) return;
    var productHandle = $btn.attr('data-handle');
    var modalID = $btn.attr('data-id');
    var noVars = false;
    if ($btn.hasClass('no-variants')) {
      noVars = true;
    }

    // Fast path: product data is rendered inline in the card (homepage product
    // sliders). Build the modal straight from local JSON — no network request,
    // so the quick view opens instantly even while the storefront is saturating
    // its per-host connection budget on a cold first load. quickBuyData() itself
    // fades the modal in, so there's no need for the spinner shell here.
    var inlineProduct = qvInlineProduct($btn);
    if (inlineProduct) {
      quickBuyData(inlineProduct, modalID, noVars);
      return;
    }

    // Slow path: fetch the product JSON (cards without inline data).
    // Open the modal shell immediately with a spinner so the click feels
    // instant even when the fetch is slow. The shared per-section modal is
    // reused across cards, so tag this open with a token; if the shopper clicks
    // another card while this fetch is in flight, the newer click wins and this
    // (stale) response is ignored instead of overwriting the modal.
    $btn.addClass('is-loading');
    var $modal = $('#' + modalID);
    var qvToken = Date.now() + '_' + Math.random();
    $modal.data('qvToken', qvToken);
    var loaderSrc = $btn.find('.loader').attr('src') || '';
    $modal.find('.modal__inner').html('<div class="qv-loading"><img src="' + loaderSrc + '" alt="" class="qv-loading__spinner"></div>');
    $modal.fadeIn('fast');

    qvFetchProduct(productHandle).then(function (product) {
      $btn.removeClass('is-loading');
      if ($modal.data('qvToken') !== qvToken) return; // superseded by a newer click
      quickBuyData(product, modalID, noVars);
    }).catch(function () {
      $btn.removeClass('is-loading');
      if ($modal.data('qvToken') !== qvToken) return;
      // Fetch failed — don't strand the shopper on a spinner; link to the PDP.
      $modal.find('.modal__inner').html('<div class="qv-loading"><a class="btn btn--dark" href="' + window.Shopify.routes.root + 'products/' + productHandle + '">View product</a></div>');
    });
  });
  $('body').on('click', '.boost-sd__button--select-option:not([aria-label="Add to cart"])', function (e) {
    var productHandle = $(this).attr('data-handle');
    var noVars = false;
    if ($(this).hasClass('no-variants')) {
      noVars = true;
    }

    // Boost split-variant cards append the colour to the product title as " - ColorName".
    // We extract it from the card's title element so the modal opens with the right
    // swatch pre-selected. Falls back to null if not found — modal defaults to first
    // available colour.
    var preselectedColor = null;
    var $card = $(this).closest('[data-product]');
    if ($card.length) {
      // Primary source: the visible product title text, e.g. "Product Name - Brown"
      var titleText = $card.find('.boost-sd__product-title').text().trim();
      var titleMatch = titleText.match(/\s-\s([^-]+)$/);
      if (titleMatch) {
        preselectedColor = titleMatch[1].trim();
      }

      // Fallback: aria-label on the product link, same format
      if (!preselectedColor) {
        var ariaLabel = $card.find('.boost-sd__product-link[aria-label]').attr('aria-label') || '';
        var ariaMatch = ariaLabel.match(/\s-\s([^-]+)$/);
        if (ariaMatch) {
          preselectedColor = ariaMatch[1].trim();
        }
      }
    }

    fetch(window.Shopify.routes.root + 'products/' + productHandle + '.js').then(function (response) {
      return response.json();
    }).then(function (product) {
      return quickBuyData(product, 'quick-view_collection', noVars, preselectedColor);
    });
  });

  /******************************************
    Footer
   ******************************************/

  // Turn footer menus into accordions on mobile
  if (windowWidth < 768) {
    $('.footer .menu h3').on('click', function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).next('ul').slideUp(250);
      } else {
        $('.footer .menu h3').removeClass('active');
        $('.footer .menu ul').slideUp(250);
        $(this).addClass('active');
        $(this).next('ul').slideDown(250);
      }
    });
  }

  /******************************************
    Product Card Swatch Images
   ******************************************/
  $('.card__swatches .swatch').on('click', function () {
    var dataImage = $(this).attr('data-image');
    var dataImageSrcset = $(this).attr('data-image-srcset');
    var dataColor = $(this).attr('data-color');
    // console.log(dataImage);
    if (dataImage.indexOf('no-image') === -1) {
      var newImage = '<img src="' + dataImage + '" srcset="' + dataImageSrcset + '" class="image--swatch image" data-color="' + dataColor + '"/>';
      $(this).closest('.card').find('.card__image a').append(newImage);
      $(this).closest('.card').find('.image--swatch').show();
      $(this).closest('.card').find('.swatch').removeClass('swatch--active');
      $(this).addClass('swatch--active');
    }
  });
  $('.card__swatches .swatch').on('mouseleave', function () {
    $(this).closest('.card').find('.image--swatch').hide();
    $(this).closest('.card').find('.image--swatch').remove();
    $(this).removeClass('swatch--active');
  });

  /******************************************
     Modals
   ******************************************/

  // Launch the modal
  $('body').on('click', '.btn--modal', function (e) {
    e.preventDefault();
    var modalID = '#' + $(this).attr('data-modal');
    // console.log(modalID);

    if ($(this)[0].hasAttribute('data-video-yt')) {
      var videoID = $(this).attr('data-video-yt');
      $(modalID).find('.modal__inner').append('<div class="iframe-wrap"><iframe width="560" height="315" src="https://www.youtube.com/embed/' + videoID + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>');
    }
    if ($(this)[0].hasAttribute('data-video-vimeo')) {
      var videoID = $(this).attr('data-video-vimeo');
      $(modalID).find('.modal__inner').append('<div class="iframe-wrap"><iframe width="560" height="315" src="https://player.vimeo.com/video/' + videoID + '"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen allowfullscreen></iframe></div>');
    }
    $(modalID).fadeIn('fast');
  });

  // Close the modal
  $('.modal--close, .modal__bg').on('click', function (e) {
    closeModal($(this));
  });
  function closeModal(object) {
    object.closest('.modal').fadeOut('fast', function () {
      $('.modal__inner .iframe-wrap').remove();
      $('.modal--quick .modal__inner').empty();
    });
  }

  /******************************************
   Quick View Modal from Product Card ( Process ATC / Variant Options Select )
   ******************************************/

  $('body').on('change', '.modal--quick .option__wrap select', function () {
    quickViewVariant();
  });
  $('body').on('click', '.modal--quick .option__wrap button', function () {
    quickViewVariant();
  });

  /******************************************
   Quick View Modal Add to Cart
   ******************************************/
  $('body').on('click', '.modal--quick .btn--atc', function () {
    var id = $(this).closest('.modal__inner').find('#variantSelector').find(':selected').attr('data-variant_id');
    var qty = $(this).closest('.modal__inner').find('.qty-val').val();
    CartJS.addItem(parseInt(id), qty, {}, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          closeModal($('.modal--quick .modal__inner'));
          window.Rebuy?.SmartCart?.show?.();
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        //error state
        console.log('Error: ' + jqXHR + '!');
      }
    });
  });
});
function quickViewVariant() {
  var matchStringArray = [];
  if ($('[data-option="sm-rc-option1-selector"]').length) {
    if ($('[data-option="sm-rc-option1-selector"]').hasClass('option__wrap--button')) {
      matchStringArray.push($('[data-option="sm-rc-option1-selector"]').find('button.active').attr('data-val'));
    } else {
      matchStringArray.push($('[data-option="sm-rc-option1-selector"]').find('select').val());
    }
  }
  if ($('[data-option="sm-rc-option2-selector"]').length) {
    if ($('[data-option="sm-rc-option2-selector"]').hasClass('option__wrap--button')) {
      matchStringArray.push($('[data-option="sm-rc-option2-selector"]').find('button.active').attr('data-val'));
    } else {
      matchStringArray.push($('[data-option="sm-rc-option2-selector"]').find('select').val());
    }
  }
  if ($('[data-option="sm-rc-option3-selector"]').length) {
    if ($('[data-option="sm-rc-option3-selector"]').hasClass('option__wrap--button')) {
      matchStringArray.push($('[data-option="sm-rc-option3-selector"]').find('button.active').attr('data-val'));
    } else {
      matchStringArray.push($('[sm-rc-option3-selector]').find('select').val());
    }
  }
  if (matchStringArray.length) {
    matchString = matchStringArray.join(' / ');
  } else {
    matchString = false;
  }

  // Deal with the ATC button
  if ($('#variantSelector option[value="' + matchString + '"]').attr('data-available') == 'true') {
    $('[sm-rc-add-to-cart]').prop('disabled', false);
    $('.oos-text').hide();
    $('.is-text').show();
  } else {
    $('[sm-rc-add-to-cart]').prop('disabled', true);
    $('.oos-text').show();
    $('.is-text').hide();
  }

  // Change the pricing
  var priceSale = $('#variantSelector option[value="' + matchString + '"]').attr('data-price');
  var priceOrig = $('#variantSelector option[value="' + matchString + '"]').attr('data-compare-price');
  if (priceSale != priceOrig && priceOrig != '$0.00') {
    $('.modal--quick .price--sale').text(priceSale);
    $('.modal--quick .price--orig').text(priceOrig);
  } else {
    $('.modal--quick .price--sale').text(priceSale);
    $('.modal--quick .price--orig').text('');
  }

  // Change the variant select
  $('#variantSelector').val(matchString).change();
}
jQuery(document).ready(function ($) {
  var windowWidth = $(window).width();

  // Init header offset function
  headerOffset();

  // Update offset on scroll
  $(window).on('scroll resize', function () {
    headerOffset();
  });

  // Update offset on alert bar close
  $('.alert-bar .close--alert').on('click', function () {
    $('.alert-bar').remove();
    headerOffset();
  });

  // Change header to white on hover
  if (windowWidth > 992) {
    $('.header').on('mouseenter', function (e) {
      if (!$('.header').hasClass('header--solid')) {
        // $('.header__bg').fadeIn(300);
        $('.header').addClass('header--white');
      }
    });
    $('.header').on('mouseleave', function (e) {
      if (!$('.header').hasClass('header--solid')) {
        // $('.header__bg').fadeOut(300);
        $('.header').removeClass('header--white');
      }
    });
  }
  $('.icon--language').on('click', function () {
    $('#LanguageList').slideToggle('fast');
  });
  $('.btn--language').on('click', function () {
    $('#LanguageListMobile').slideToggle('fast');
  });
  $('#LanguageList a').on('click', function (e) {
    e.preventDefault();
    $(this).closest('form').find('input[name="language_code"]').val(e.currentTarget.dataset.value);
    // console.log(e.currentTarget.dataset.value);
    $('#localization_form').submit();
  });
  $('#LanguageListMobile a').on('click', function (e) {
    e.preventDefault();
    $(this).closest('form').find('input[name="language_code"]').val(e.currentTarget.dataset.value);
    // console.log(e.currentTarget.dataset.value);
    $('#localization_form-mobile').submit();
  });

  // Deal with search open/close on mouseleave
  $('.desktop-search').on('mouseleave', function () {
    // $('.desktop-search').fadeOut('fast', '', function () {
    // 	$('body').removeClass('search-open');
    // });
  });

  // Detect mouseenter on the parent li
  $('li.top-level').on('mouseenter', function () {
    $(this).find('ul.sub-menu').stop(true, true).slideDown(200); // Show submenu
  });

  // Detect mouseleave on the parent li
  $('li.top-level').on('mouseleave', function () {
    var submenu = $(this).find('ul.sub-menu');

    // Use a timeout to delay hiding the submenu, allowing the user to move to the submenu
    setTimeout(function () {
      if (!submenu.is(':hover')) {
        submenu.stop(true, true).slideUp(200); // Hide submenu
      }
    }, 200); // Delay hiding by 300ms to allow mouse transition
  });

  // Also detect mouseleave on the submenu itself
  $('ul.sub-menu').on('mouseleave', function () {
    $(this).stop(true, true).slideUp(200); // Hide submenu
  });

  // Offset content from fixed header
  function headerOffset() {
    var headerHeight = $('.fixed-wrap').innerHeight();
    $('#main').css('padding-top', headerHeight + 'px');

    // $('.pdp__images').css('top', headerHeight + 'px');
    $('.mini-cart').css('height', 'calc( 100vh - ' + headerHeight + 'px )');
    $(window).on('scroll resize', function () {
      var newsHeight = $('.fixed-wrap .alert-bar').innerHeight();
      if ($(window).scrollTop() >= 250) {
        $('.fixed-wrap').addClass('scrolling');
        if (!$('.header').hasClass('header--solid')) {
          $('.header').addClass('header--white');
        }
        if (newsHeight != undefined) {
          $('.fixed-wrap').css('transform', 'translateY(-' + newsHeight + 'px)');
        }
        $('.mobile-menu__inner').css('height', 'calc( 100vh - ' + headerHeight + 'px )');
      } else {
        $('.fixed-wrap').removeClass('scrolling');
        $('.fixed-wrap').css('transform', 'translateY(0)');
        if (!$('.header').hasClass('header--solid')) {
          $('.header').removeClass('header--white');
        }
      }
    });
  }
});
jQuery(document).ready(function ($) {
  // Close mini cart
  $('.mini-cart__bg, .mini-cart__content .close').on('click', function () {
    closeMini();
  });

  // Show mini cart
  $('.header .icon--cart').on('click', function (e) {
    e.preventDefault();
    if (!$('body').hasClass('template__cart')) {
      showMini();
    } else {
      e.preventDefault();
    }
  });

  // Mini Cart Remove Product
  $('.mini-cart').on('click', '.remove-product', function () {
    var lineNum = $(this).closest('.product').attr('data-lineid');
    $(this).closest('.product').addClass('removed');
    CartJS.removeItem(lineNum, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    });
  });

  // Mini Cart Upsell ATC
  $('.mini-cart__upsell .action--atc').on('click', function (e) {
    e.preventDefault();
    var dataId = $(this).closest('.upsell').attr('data-id');
    CartJS.addItem(dataId, 1, {}, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    });
  });

  // Mini Cart Qty
  $('.mini-cart__list').on('click', '.js-qty--mini', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
    var lineData = $this.closest('.product').data('lineid');
    var lineNum = $('[data-lineID="' + lineData + '"]').index();
    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    }
    CartJS.updateItem(lineNum + 1, qtyInputVal, {}, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    });
  });

  // Allow typing of input qty for update
  var timer;
  $('.mini-cart__list').on('keyup', '.actions .qty-val', function () {
    var $this = $(this);
    var newVal = $this.val();
    var lineData = $this.closest('.product').data('lineid');

    // clear the previous timer
    clearTimeout(timer);

    // create a new timer with a delay of 300ms seconds,
    // if the keyup is fired before the 300ms secs then the timer will be cleared
    timer = setTimeout(function () {
      // this will be executed if there is a gap of 300ms seconds between 2 keyup events
      // console.log(newVal);
      CartJS.updateItem(lineData, newVal, {}, {
        success: function success(data, textStatus, jqXHR) {
          jQuery.getJSON('/cart.js', function (cart) {
            refreshMiniCart(cart);
          });
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
      });
    }, 300);
  });
});
function closeMini() {
  $('body').removeClass('cart-open');
  $('.mini-cart').removeClass('is-open');
  $('.mini-cart').fadeOut('fast');
}
function showMini() {
  $('body').addClass('cart-open');
  $('.mini-cart').fadeIn('fast');
  $('.mini-cart').addClass('is-open');

  // Set height of product list for full-height mini-cart
  // var miniHead = parseInt( $( '.mini-cart__header' ).innerHeight() );
  // var miniShip = parseInt( $( '.mini-cart__ship' ).innerHeight() );
  // var miniFooter = parseInt( $( '.mini-cart__footer' ).innerHeight() );
  // var miniUp = parseInt( $( '.mini-cart__upsell' ).innerHeight() );
  // var miniTotalHeight = miniHead + miniShip + miniFooter + miniUp;
}
function refreshMiniCart(cartData) {
  // Set new header icon count
  $('.icon--cart .cart-count span ').text(cartData.item_count);
  // var cartItems = cartData.items;
  // var newCartHtml = '';

  // // Free shipping updater
  // var totalShip = parseInt( $( '.mini-cart' ).data( 'freeship' ) );
  // var newCartTotal = cartData.items_subtotal_price;
  // var awayShip = totalShip - newCartTotal;
  // var shipPercent = ( newCartTotal / totalShip ) * 100;

  // if ( shipPercent >= 100 ) {
  //   $( '.shipping-bar--progress' ).css( 'width', '100%' );
  //   $( '.mini-cart__ship' ).addClass( 'is-free' );
  // } else {
  //   if ( $( '.mini-cart__ship' ).hasClass( 'is-free' ) ) {
  //     $( '.mini-cart__ship' ).removeClass( 'is-free' )
  //   }
  //   $( '.free-count' ).text( formatter.format( awayShip / 100) );
  //   $( '.shipping-bar--progress' ).css( 'width', shipPercent+'%' );
  // }

  // // If cart is now empty
  // if ( cartData.item_count == 0 ) {
  //   newCartHtml += ' <h3 class="text-center">Cart is empty</h3>';
  // } else {

  // 	// Build html of new products in cart
  // 	$.each(cartItems, function(index, item) {
  // 		// Opening
  // 		newCartHtml += '<div class="product product--cart d-flex justify-between" data-lineid="'+( index + 1 )+'">';

  // 			newCartHtml += ' <div class="product__image">';
  // 				if (  item.featured_image ) {
  // 					newCartHtml += '<a href="' + item.url + '">';
  // 						newCartHtml += '<img src="' + item.featured_image.url.replace('.jpg', '_80x.jpg').replace( '.png', '_80x.png' ) + '" srcset="' + item.featured_image.url.replace('.jpg', '_160x.jpg').replace( '.png', '_160x.png' ) + ' 2x" alt="' + item.image.alt +'">';
  // 					newCartHtml += '</a>';
  // 				}
  // 			newCartHtml += '</div>';
  // 			newCartHtml += '<div class="product__info">';
  // 				newCartHtml += '<div class="title d-flex">';
  // 					newCartHtml += '<h3 class="heading--four d-flex justify-between">'
  // 						newCartHtml += '<a class="no-dec trans" href="' + item.url + '">';
  // 							newCartHtml += item.product_title;
  // 						newCartHtml += '</a>';
  // 						newCartHtml += ' <button class="remove-product trans"><span class="sr-only">Remove</span><img src="//cdn.shopify.com/s/files/1/0506/7037/0997/t/2/assets/icon-close.svg?v=18585775398919142161649090024" alt="" /></button>';
  // 					newCartHtml += '</h3>'
  // 					if ( item.options_with_values != null && item.options_with_values[0].name != 'Title' ) {

  // 								$.each( item.options_with_values, function( index, value ) {
  // 									console.log( 'index:'+index );
  // 									console.log( 'value:'+value );
  // 									newCartHtml += '<div class="var">';
  // 										newCartHtml += '<span>'+item.options_with_values[index].name+': '+item.options_with_values[index].value+'</span>';
  // 									newCartHtml += '</div>';
  // 								} );

  // 						}
  // 					if ( item.hasOwnProperty( 'selling_plan_allocation' ) ) {
  // 						newCartHtml += '<span class="delivery">'+ item.selling_plan_allocation.selling_plan.name +'</span>';
  // 					}
  // 					newCartHtml += '<span class="unit-price">'+formatter.format(item.price / 100)+'</span>';
  // 				newCartHtml += '</div>';
  // 				// newCartHtml += '<div class="price">'+formatter.format(item.final_line_price / 100)+'</div>';
  // 				newCartHtml += `<div class="actions d-flex align-center justify-between">
  // 					<div class="action action--qty">
  // 						<div class="qty d-flex align-center">
  // 							<button class="js-qty js-qty--mini js-qty--minus trans">
  // 								<span class="sr-only">Decrease</span>
  // 							</button>
  // 							<input sm-rc-quantity-selector type="text" value="` + item.quantity + `" min="1"  type="number" class="qty-val" />
  // 							<button class="js-qty js-qty--mini js-qty--plus trans">
  // 								<span class="sr-only">Increase</span>
  // 							</button>
  // 						</div>
  // 					</div>`;
  // 					newCartHtml += '<div class="price">'+formatter.format(item.final_line_price / 100)+'</div>'
  // 				newCartHtml += '</div>';

  // 			// Closing
  // 			newCartHtml += '</div>';
  // 		newCartHtml += '</div>';
  // 	});
  // }

  // // Clear current products in cart
  // $('.mini-cart__items').empty();

  // // Set new subtotal
  // $('.mini-cart__footer .sub-total .total').text(formatter.format(cartData.total_price / 100));

  // // Add updated producst to mini cart
  // $('.mini-cart__list').html(newCartHtml);

  // // Show mini cart
  // showMini();
}
jQuery(document).ready(function ($) {
  // Addons active state
  $('.addon input').on('click', function () {
    $(this).closest('label').toggleClass('active');
  });
});


// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file.

console.log('%c This site was designed & developed by https://www.sleeplessmedia.com', 'background:#000; color: #ae956e; padding: 10px 15px; font-size: 13px; font-weight: 500; width: 100%;');

// Cookies functions
function setCookie(cookieName, cookieValue) {
  var today = new Date();
  var expire = new Date();
  expire.setTime(today.getTime() + 3600000 * 24 * 7);
  document.cookie = cookieName + '=' + encodeURI(cookieValue) + ';expires=' + expire.toGMTString();
}
function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}